import { useEffect, useMemo, useState } from 'react'
import CreatorPortal from '../../components/CreatorPortal'
import { translate } from '../../configuration/localization'
import { Centered } from '../../ui/foundation/LegacyPrimitives'
import { AuthScreen } from '../auth/public'
import { platformApi, type AuthSession } from '../platform/public'
import { WorkspaceScreen } from '../workspace/public'

export function AppRoot() {
  const [session, setSession] = useState<AuthSession | null>(null)
  const [loading, setLoading] = useState(true)
  const creatorToken = useMemo(() => window.location.pathname.match(/^\/creator\/([0-9a-f]{64})$/)?.[1] ?? '', [])

  useEffect(() => {
    if (creatorToken) {
      setLoading(false)
      return
    }

    platformApi.auth.getSession().then((result) => {
      setSession(result.data)
      setLoading(false)
    })
    return platformApi.auth.onSessionChange(setSession)
  }, [creatorToken])

  if (creatorToken) return <CreatorPortal token={creatorToken} />
  if (loading) return <Centered title={translate('app.loadingSession')} />
  if (!session) return <AuthScreen />
  return <WorkspaceScreen user={session.user} />
}
